import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import { LoginService } from './login/login.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl:'/app.topbar.scss'
})
export class AppTopBarComponent implements OnInit,OnDestroy {
public top_username:string;
public top_language:number;
public top_userrealname:string;
public slider: boolean = true;
public subs: Subscription[]=[];
    constructor(private router:Router, private route:ActivatedRoute, public app: AppComponent, public appMain: AppMainComponent, public loginService: LoginService)

    {



        //deleteing subscriptions with a take(1) thing

    }
    ngOnInit(): void {
        this.subs.push(
            this.loginService.user$.subscribe(x=> {
                if(x!=null){
                    this.top_username = x.username;
                    this.top_language = x.languageId;
                    this.top_userrealname = x.argicModel?.contact?.FirstName + ' ' + x.argicModel?.contact?.LastName;
                } else {
                    this.top_username = null;
                    this.top_language = null;
                    this.top_userrealname = null;
                }
            }));


    }

    showSlider(){

        const url = this.router.url;
            if(url.includes("contact")     ){
               return  true;
            } else {
                return false;
            }
    }


    doSiteSearch(query:string){
        this.appMain.siteSearchQuery.next(query);

    }


    ngOnDestroy(): void {
        this.subs.forEach(element => {
            element.unsubscribe();
        });
    }

    showMyArgic() {
        const url = this.router.url;
        if (!url.includes("register")) {
            return true;
        } else {
            return false;
        }
    }
}
